module.exports = __webpack_public_path__ + "static/media/next-week.52999ea2.png";